module.exports = __webpack_public_path__ + "static/img/zi5.7a139d41.png";